import React from 'react';

import { Palettes } from '../../PaletteGeneration';
import type { ButtonProps } from '../Button.types';
import {
    checkedInverseViews,
    inverseViews,
    staticViews,
    viewsWithCheckedState,
} from '../constants';

export type UseContentPaletteProps = Pick<ButtonProps, 'view' | 'isDisabled'> & {
    isChecked?: boolean;
};

export const useButtonPalette = (props: UseContentPaletteProps) => {
    const { view, isDisabled, isChecked } = props;

    const isContentInversed = React.useMemo(() => {
        if (isDisabled || !view) {
            return false;
        }

        return isChecked && viewsWithCheckedState.has(view)
            ? checkedInverseViews.has(view)
            : inverseViews.has(view);
    }, [view, isChecked, isDisabled]);

    const isContainerStatic = React.useMemo(() => view && staticViews.has(view), [view]);

    return {
        containerPalette: isContainerStatic ? Palettes.static : undefined,
        contentPalette: isContentInversed ? Palettes.inverse : undefined,
    };
};
